import createCache from 'services/createCache';

export default createCache({
	freerideMap: {
		map: null,
		buildingsLayer: null,
		mapLayer: null,
		markerLayer: null,
	},
});
